<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner whole">
        <div class="modal">
          <header class="header">
            <div class="inner">
              <h1 class="ttl">주소 검색</h1>
              <div class="right">
                <button class="header-btn" @click="close"><i class="ico-close-gray90"></i></button>
              </div>
            </div>
          </header>
          <div class="kakao-post" ref="kakaoPost" style="margin:0 !important;"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { onBeforeMount, ref } from 'vue';
import { loadScript, unloadScript } from 'vue-plugin-load-script';
import ConstCode from '@/common/constants/ConstCode';
const emits = defineEmits(['close']);
const props = defineProps(['data']);
const { fnCallBack } = props.data;
const postUrl = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
const kakaoPost = ref();

onBeforeMount(() => {
  load();
});
const load = async () => {
  const postUrl = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
  // 2. 우편번호 API
  await loadScript(postUrl);

  // 3. 우편번호 검색창 오픈
  new daum.Postcode({
    onComplete: completeSearch,
    width: '100%',
    height: '100%'
  }).embed(kakaoPost.value);
};

const unload = () => {
  unloadScript(postUrl);
  kakaoPost.value = '';
};
const completeSearch = async data => {
  const fullAddress = data.address;
  // 주소 → 좌표 변환
  return new Promise(resolve => {
    if (!window.kakao || !window.kakao.maps) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = `//dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=${ConstCode.CODE_ENV_LIST.KAKAO_KEY}&libraries=services`;
      script.onload = () => {
        kakao.maps.load(() => {
          search(fullAddress, data);
        });
      };
      document.head.appendChild(script);
    } else {
      search(fullAddress, data);
      resolve(true);
    }
  });
};

const search = (fullAddress, data) => {
  const geocoder = new kakao.maps.services.Geocoder();

  geocoder.addressSearch(fullAddress, function(result, status) {
    if (status === kakao.maps.services.Status.OK) {
      const lat = result[0].y;
      const lng = result[0].x;
      const finalData = {
        ...data, // 기존 주소 정보
        latitude: lat, // 추가된 위도
        longitude: lng // 추가된 경도
      };
      if (fnCallBack) fnCallBack(finalData); // 부모로 전송
    } else {
      if (fnCallBack) fnCallBack({ ...data, error: '좌표 변환 실패' });
    }

    unload();
    emits('close');
  });
};
const close = () => {
  console.log('close');
  setTimeout(() => {
    emits('close');
  }, 200);
};
</script>

<style scoped>
.kakao-post {
  margin-top: 6rem;
  height: 100%;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
